import React from 'react';
import { cn } from '../../lib/utils';

export const Input = React.forwardRef(
  ({ className, label, error, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-label-md text-brand-black/70 mb-2">
            {label}
          </label>
        )}
        <input
          className={cn(
            "w-full px-4 py-3 bg-white border border-brand-black/15 text-body-md text-brand-black placeholder:text-brand-black/40 transition-all duration-300 focus:outline-none focus:border-brand-cobalt focus:ring-1 focus:ring-brand-cobalt disabled:bg-brand-black/5 disabled:cursor-not-allowed",
            error && "border-red-500 focus:border-red-500 focus:ring-red-500",
            className
          )}
          ref={ref}
          {...props}
        />
        {error && (
          <p className="mt-1 text-body-sm text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";

export const Textarea = React.forwardRef(
  ({ className, label, error, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-label-md text-brand-black/70 mb-2">
            {label}
          </label>
        )}
        <textarea
          className={cn(
            "w-full px-4 py-3 bg-white border border-brand-black/15 text-body-md text-brand-black placeholder:text-brand-black/40 transition-all duration-300 focus:outline-none focus:border-brand-cobalt focus:ring-1 focus:ring-brand-cobalt disabled:bg-brand-black/5 disabled:cursor-not-allowed min-h-[120px] resize-y",
            error && "border-red-500 focus:border-red-500 focus:ring-red-500",
            className
          )}
          ref={ref}
          {...props}
        />
        {error && (
          <p className="mt-1 text-body-sm text-red-600">{error}</p>
        )}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";
